import { SelectComponent } from '../../../Opten.HypothekarbankLenzburg.Core.Static/components/select/select';
import { Component } from '@opten/compiler/metadata/component';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { ChildrenRef } from '@opten/compiler/metadata/di';
import { getCss } from '@opten/dom/get-css';
import { parseCssUnit } from '@opten/number/parse-css-unit';
import { scrollToElement } from '@opten/scroll/scroll-to-element';
import { linearTween } from '@opten/animation/linear-tween';
import { easeInOutQuad } from '@opten/animation/ease-in-out-quad';
import { removeClass } from '@opten/dom/remove-class';
import { addClass } from '@opten/dom/add-class';
import { hasClass } from '@opten/dom/has-class';
import { getStickyOffset } from '../utilities/scroll-helper';
import { Collapse } from '@opten/collapse/initializer';
import { dialog } from '@opten/dialog';
import { mapFields,getFields, setFieldsFromJson } from '../utilities/form';
import { setStorage, getStorage, deleteStorage } from '../utilities/storage';
import { PAD_WIDTH } from './../utilities/detection';
import { MortgageFundingProposalFormKey, ignoreReadMortgage } from './mortgage-funding-proposal-form';

import { Select, SelectOptions } from '@opten/select';

const inDuration = 450;
const outDuration = 300;

@Component({ className: 'js-mortgage-calculator' })
export default class MortgageCalculator implements OnInit {
	private _ignoreRead = ignoreReadMortgage;
	private _proposalElement: HTMLElement;
	private _formElement: HTMLFormElement;
	private _tabElements: Array<HTMLAnchorElement>;

	private _hasProposal: boolean = false;
	private _cookieChecked: boolean = false;
	private _loadingIndicator = '<div class="c-loading-indicator">Loading...</div>';
	private _typeSelect: Select;

	@ChildrenRef(SelectComponent)
	_selects: Array<SelectComponent>;


	constructor(private element: HTMLElement) {
		this._proposalElement = element.getElementsByClassName(
			'js-mortgage-calculator-proposal'
		)[0] as HTMLElement;
		this._formElement = this.element.getElementsByClassName(
			'js-mortgage-calculator-form'
		)[0] as HTMLFormElement;
		this._tabElements = Array.from(
			this.element.getElementsByClassName('js-mortgage-calculator-tab')
		) as Array<HTMLAnchorElement>;
	}

	onInit() {
		this._formElement.addEventListener('submit', event => {
			event.preventDefault();
			this._fetch();
		});

		this._typeSelect = this._selects.find(
			// bug in select() that js-select is also applied to created element
			// therefore multiple instances are found...
			o => o && o.select.name && o.select.name === 'Type'
		).select;

		this._typeSelect.htmlSelectElement.addEventListener('change', () => {
			// todo: way to not going over the tab?
			const tab = this.element.querySelector<HTMLAnchorElement>(
				`a[data-value='${this._typeSelect.value}']`
			);

			this._collapse(tab);
			this._saveCookie();
		});

		this._tabElements.forEach((tab: HTMLAnchorElement) =>
			tab.addEventListener('click', event => {
				event.preventDefault();

				if (hasClass(tab.parentElement, '--active')) {
					return;
				}

				this._typeSelect.htmlSelectElement.value = tab.getAttribute('data-value');
				this._typeSelect.htmlSelectElement.dispatchEvent(new Event('change'));
				this._collapse(tab);
				this._saveCookie();
			})
		);

		const checkboxCookie = this.element.querySelector<HTMLInputElement>(
			`input[name='Cookie'][type='checkbox']`
		);

		if (checkboxCookie) {			
			this._handleCookie(checkboxCookie);
		}

	}

	private _handleCookie(checkbox: HTMLInputElement) {
		checkbox.addEventListener('change', event => {
			event.preventDefault(); // prevent checked = false;
			this._cookieChecked = checkbox.checked;
			if(checkbox.checked === false){

				// todo: better way? why private?
				(dialog(
					document.getElementById(
						'c-dialog-mortgage-calculator-cookie'
					),
					{
						maxWidth: PAD_WIDTH
					}
				) as any).open();
			}
			else{
				 // store initial cookie (Calculator)
				 this._saveCookie();				 
			}
		});

		const cookie = getStorage(MortgageFundingProposalFormKey);
		if (cookie) {
			checkbox.checked = true;			
			this._cookieChecked = true;

			try {
				const json = JSON.parse(cookie);

				setFieldsFromJson(
					this._formElement,
					this._selects.map(o => o.select),
					json,
					[],
					(field, propName) =>
						(propName.toLowerCase().indexOf('calculator.') !== -1 &&
						field.name === propName.split('.')[1]) ||
						(field.name === 'Email' && propName === 'Email')||
						(field.name === 'Phone' && propName === 'Phone')

				);

				// todo: way to not going over the tab?
				const tab = this.element.querySelector<HTMLAnchorElement>(
					`a[data-value='${json['Calculator.Type']}']`
				);
				this._typeSelect.htmlSelectElement.value = tab.getAttribute('data-value');
				this._typeSelect.htmlSelectElement.dispatchEvent(new Event('change'));
				this._collapse(tab);
			} catch {
				/* todo: do we need to handle here something? */
			}
		}
		getFields(this._formElement, this._ignoreRead).forEach(field => {
			if (field.tagName === 'select') {
				field.addEventListener('change', () => this._saveCookie());
			} else {
				field.addEventListener('blur', () => this._saveCookie());
			}
		});
	}

	private _saveCookie(){
		if(this._cookieChecked){
			const cookie = getStorage(MortgageFundingProposalFormKey);
			const json = cookie ? JSON.parse(cookie) : {};
			mapFields(this._formElement, this._ignoreRead).forEach(
				(value, key) => ((key === 'Email' || key === 'Phone') ? json[key] = value : json['Calculator.' + key] = value)
			);
	
			setStorage(MortgageFundingProposalFormKey, JSON.stringify(json));
		}
	}

	private _collapse(tab: HTMLAnchorElement) {
		if (!tab) {
			return;
		}

		this._tabElements.forEach(tab =>
			removeClass(tab.parentElement, '--active')
		);
		addClass(tab.parentElement, '--active');

		const selector = tab.getAttribute('href').substring(1);
		const target = document.getElementById(selector);

		Array.from(
			document.getElementsByClassName('mortgage-calculator__collapse')
		)
			.filter(o => o !== target)
			.forEach(o => removeClass(o, '--show'));

		if (!hasClass(target, '--show')) {
			addClass(target, '--show');
		}
	}

	private _apply(link: HTMLAnchorElement) {
		if (link.hasAttribute('data-proposal-id')) {
			const form = document.createElement('form');
			form.method = 'POST';
			form.action = link.href;
			form.style.display = 'none';

			// todo: better way for ufprt?
			mapFields(this._formElement, ['ufprt']).forEach((value, key) =>
				form.appendChild(this._createHiddenInput(key, value))
			);

			form.appendChild(
				this._createHiddenInput(
					'ProposalId',
					link.getAttribute('data-proposal-id')
				)
			);

			form.appendChild(
				this._createHiddenInput(
					'SpanIds',
					link.getAttribute('data-span-ids')
				)
			);

			document.body.appendChild(form);
			form.submit();
		}
	}

	private _createHiddenInput(name: string, value: any): HTMLInputElement {
		const input = document.createElement('input');
		input.type = 'hidden';
		input.name = name;
		input.value = value;
		return input;
	}

	private _fetch() {
		this._proposalElement.style.overflow = 'hidden';

		const get = () => {
			const formData = new FormData();
			mapFields(this._formElement).forEach((value, key) =>
				formData.append(key, value)
			);
			this._proposalElement.innerHTML = this._loadingIndicator;

			fetch(this._formElement.action, {
				method: this._formElement.method,
				headers: {
					// todo: set language from chooser in the future
					'accept-language': 'de-CH',
					// todo: why? if we change to a api controller we don't have this problem...
					'X-Requested-With': 'XMLHttpRequest' // otherwise accept-language is ignored
				},
				body: formData
			})
				.then(response => {
					if (response.ok) {
						const contentType = response.headers.get(
							'content-type'
						);

						if (contentType && contentType.includes('text/html')) {
							return response.text();
						}
					}

					return null;
				})
				.then(html => {
					if (html) {
						// todo: kill events?
						this._proposalElement.innerHTML = html;

						// initialize collapse
						Array.from(
							this._proposalElement.getElementsByClassName(
								'js-mortgage-calculator-proposal-collapse'
							)
						).forEach(element =>
							new Collapse(element as HTMLElement).hide()
						);

						// initialize selects
						Array.from(
							this._proposalElement.getElementsByClassName(
								'js-select '
							)
						).forEach(element =>
							new Select(element as HTMLSelectElement, {
								classes: {
									component: 'c-select',
									active: '--active',
									highlighted: '--highlighted',
									disabled: '--disabled',
									iconHtml: ''
								}
							} as SelectOptions)
						);

						// initialize spans
						Array.from(
							this._proposalElement.getElementsByClassName(
								'js-select-mortgage-calculator-proposal-span'
							)
						).forEach(select =>
							select.addEventListener('change', () =>
								this._onChangeEvent(select as HTMLSelectElement)
							)
						);
					} else {
						// todo: apply in html and get with javascript for translation?
						this._proposalElement.innerHTML = `<div class="alert alert-danger">
                            Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.
                        </div>`;
					}

					this._show();
				});
		};

		if ($(this._formElement).valid()) {
			if (this._hasProposal) {
				this._hide(() => get());
			} else {
				get();
			}
		}
	}

	private _show() {
		this._proposalElement.style.display = 'block';
		this._animate(0, this._proposalElement.offsetHeight, inDuration);

		let offset = getStickyOffset();
		offset += parseCssUnit(getCss(this._proposalElement, 'margin-top'));

		scrollToElement(
			this._proposalElement,
			linearTween,
			inDuration,
			offset * -1
		);

		this._hasProposal = true;

		Array.from(
			this.element.getElementsByClassName(
				'js-mortgage-calculator-proposal-apply'
			)
		).forEach((link: HTMLAnchorElement) =>
			link.addEventListener('click', event => {
				event.preventDefault();

				this._apply(link);
			})
		);
	}

	private _hide(callback: Function) {
		if (!this._hasProposal) {
			callback();
		} else {
			this._animate(
				this._proposalElement.offsetHeight,
				this._proposalElement.offsetHeight * -1,
				outDuration,
				() => {
					this._proposalElement.style.display = 'none';
					this._hasProposal = false;
					callback();
				}
			);
		}
	}

	private _onChangeEvent(element: HTMLSelectElement) {
		const mortgageId = element.getAttribute('data-mortgage-id');
		const proposalId = element.getAttribute('data-proposal-id');

		const all = Array.from(
			document.querySelectorAll<HTMLElement>(
				`[data-proposal-id="${proposalId}"].js-mortgage-calculator-proposal-details,
                [data-mortgage-id="${mortgageId}"][data-proposal-id="${proposalId}"].js-mortgage-calculator-proposal-table`
			)
		);

		const others = all.filter(
			o => o.getAttribute('data-span-id') !== element.value
		);

		// todo: collapse or use _animate method?
		others.forEach(element => (element.style.display = 'none'));

		// todo: collapse or use _animate method?
		all.filter(element => others.indexOf(element) < 0).forEach(
			element => (element.style.display = 'block')
		);

		const button = document.querySelector<HTMLElement>(
			`[data-proposal-id="${proposalId}"].js-mortgage-calculator-proposal-apply`
		);

		if (button) {
			const spanIds = button.getAttribute('data-span-ids').split(',');

			spanIds.splice(
				spanIds.indexOf(element.getAttribute('data-old-id')),
				1,
				element.value
			);

			element.setAttribute('data-old-id', element.value);
			button.setAttribute('data-span-ids', spanIds.join(','));
		}
	}

	private _animate(
		start: number,
		distance: number,
		duration: number,
		complete?: Function
	) {
		// todo: function in @opten/events?
		let timeStart: number;
		let timeElapsed: number;

		const loop = time => {
			timeElapsed = time - timeStart;

			this._proposalElement.style.height = `${easeInOutQuad(
				timeElapsed,
				start,
				distance,
				duration
			)}px`;

			if (timeElapsed < duration) {
				requestAnimationFrame.call(window, loop);
			} else {
				this._proposalElement.style.height = null;
				if (complete) {
					complete();
				}
			}
		};

		requestAnimationFrame.call(window, time => {
			timeStart = time;
			loop(time);
		});
	}
}

@Component({ className: 'js-mortgage-calculator-cookie-save', observe: true })
export class MortgageCalculatorCookieSave {
	constructor(private element: HTMLElement) {
		if (element.hasAttribute('data-id')) {
			element.addEventListener('click', () => {
				const id = element.getAttribute('data-id');
				const checkbox = document.querySelector<HTMLInputElement>(
					'[id="' + id + '"]'
				);

				if (checkbox) {
					checkbox.checked = true;
				}
			});
		}
	}
}

@Component({ className: 'js-mortgage-calculator-cookie-delete', observe: true })
export class MortgageCalculatorCookieDelete {
	constructor(private element: HTMLElement) {
		if (element.hasAttribute('data-id')) {
			element.addEventListener('click', () => {
				const id = element.getAttribute('data-id');
				const checkbox = document.querySelector<HTMLInputElement>(
					'[id="' + id + '"]'
				);

				if (checkbox) {
					checkbox.checked = false;
					deleteStorage(MortgageFundingProposalFormKey);
				}
			});
		}
	}
}

